// axios配置
import axios from 'axios/index'
import NProgress from 'nprogress'
import storage from './storage'
import global from './global'

axios.defaults.timeout = 30000;   // 超时时间
axios.defaults.baseURL = global.config.baseUrl;

let count = 0;

//整理数据
axios.defaults.transformRequest = function (data) {
    data = JSON.stringify(data);
    return data;
};

// basic request 拦截器
axios.interceptors.request.use(
    config => {
        count++;
        if (count > 0) {
            NProgress.start();
        }
		
		console.log(config);
		
		if (config.url == "https://up-z2.qiniup.com"){
			 config.headers['Content-Type'] = 'multipart/form-data';
		}else{
			 config.headers['Content-Type'] = 'application/json;charset=UTF-8';
		}
		
       
        //判断是否存在ticket，如果存在的话，则每个http header都加上ticket
        if (storage.getToken()) {
            config.headers['X-TOKEN'] = storage.getToken().token;
        } else {
            config.headers['X-TOKEN'] = '';
        }
        return config;
    },
    error => {
        return Promise.reject(error.response);
    });

// basic response 拦截器
axios.interceptors.response.use(
    response => {
        count--;
        if (0 === count) {
            NProgress.done();
        }
        // if (!response || !response.data || !response.data.Code) {
        if (!response || !response.data) {
            return {
                data: {
                    Msg: "未知错误！",
                    Code: "-1",
                    Result: null
                }
            }
        } else {
            if (response.data.Code === "6018") {
                // alert(response.data.Msg);
                // 统一添加登陆组建登陆 todo
            }
        }
        return response
    },
    error => {
        count--;
        if (0 === count) {
            NProgress.done();
        }
        return Promise.reject(error.response)   // 返回接口返回的错误信息
    });
export default axios